import React from 'react';
import {View, StyleSheet } from '@react-pdf/renderer';
import AgentTableHeader from './AgentTableHeader'
import AgentTableRow from './AgentTableRow'
import InvoiceTableBlankSpace from './InvoiceTableBlankSpace'
import InvoiceTableFooter from './InvoiceTableFooter'

const tableRowsCount = 11;

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
        borderWidth: 1,
        borderColor: '#bff0fd',
    },
});

  const AgentItemsTable = ({invoice}) => (
   
    <View style={styles.tableContainer}>
        <AgentTableHeader />
        <AgentTableRow items={invoice} />
        {/* <InvoiceTableBlankSpace rowsCount={ tableRowsCount} />
        <InvoiceTableFooter items={invoice.items} /> */}
    </View>
  );
  
  export default AgentItemsTable